import { useEffect, useState } from 'react';

const RobotsTxtViewer = () => {
  const [robotsContent, setRobotsContent] = useState('');

  useEffect(() => {
    const domain=window.location.hostname;
    const data={
        "domain":domain
    }
    fetch('https://api-new.fusionkitchen.co.uk/robotsTxt', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data) // Replace 'data' with your actual payload
      })
      .then((res) => res.text())
      .then((text) => {
        setRobotsContent(text);
      })
      .catch((err) => {
        console.error('Failed to fetch robots.txt:', err);
      });
  }, []);

  return (
    <div>
      <pre >
        {robotsContent}
      </pre>
    </div>
  );
};

export default RobotsTxtViewer;
